import { Injectable, inject } from '@angular/core';
import { InternalApiConfig, ExternalApiConfig, OutlawCoreConfig } from '../../types';
import { OUTLAW_CORE_CONFIG } from '../../providers/config.provider';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private coreConfig = inject<OutlawCoreConfig>(OUTLAW_CORE_CONFIG);

  get config(): OutlawCoreConfig {
    return this.coreConfig;
  }

  get apiConfig(): Partial<InternalApiConfig> {
    return this.coreConfig.api;
  }

  get externalApiConfig(): Partial<ExternalApiConfig> {
    return this.coreConfig.externalApi;
  }
}
